import React from 'react'
import { Button, FormGroup, InputGroup, Intent } from '@blueprintjs/core'
import { toast } from 'enablex/shared'
import style from './style.scss'
import CopyIcon from '~/icons/CopyIcon'

export const MessengerConfigDialog = ({ parent }) => {

    const onInputChange = (event) => {
        // @ts-ignore
        parent.setState({
            messaging: {
                channels: {
                    ...parent?.state?.messaging?.channels,
                    messenger: {
                        ...parent?.state?.messaging?.channels?.messenger,
                        [event.target.name]: event.target.value,
                        enabled: parent.state.isFacebookEnabled
                    }
                }
            }
        })
    }

    const copyURLToClipboard = async () => {
        const preElement = document.querySelector('pre#messenger-webhook-url')
        const codeText = preElement?.textContent
        if(codeText) {
        navigator.clipboard.writeText(codeText)
        .then(() => {
            console.log('Text copied to clipboard')
            toast.info('Copied to clipboard')
        })
        .catch((error) => {
            console.error('Failed to copy text to clipboard:', error)
        })
        }
    }

    const formGroupStyle = {
        marginBottom: 0
    }

    return (
        <>
            <div>
                <div className={style.stepSubTitle}>Enter the configuration details for Messenger.</div>
                <p style={{ fontSize: '14px', color: '#838383' }}>Ensure all fields are completed for successful setup.</p>
            </div>
            <div style={{ maxWidth: '100%', height: 'auto', overflowY: 'auto' }} >
                <div className={style.formWrapper}>
                    <div style={{ display: 'grid', gridTemplateColumns: '100%', justifyContent: 'space-around' }}>
                        <FormGroup style={formGroupStyle} label="Webhook URL" labelFor="messenger-webhook-url" helperText="Copy this webhook URL. This URL will be used to receive messages and updates from the Messenger platform.">
                            <div className={style.urlContainer}>
                                <pre id="messenger-webhook-url">{`https://${window.location.host}/api/v1/messaging/webhooks/v1/${parent.state.botId}/messenger`}</pre>
                                <Button
                                    className={style.copyBtn}
                                    icon={<CopyIcon />}
                                    tabIndex={3}
                                    onClick={copyURLToClipboard}
                                    intent={Intent.PRIMARY}
                                />
                            </div>
                        </FormGroup>
                        <div style={{ display: 'grid', gridTemplateColumns: '49% 49%', justifyContent: 'space-between' }}>
                            <FormGroup style={formGroupStyle} label="App ID" labelInfo={<span style={{color: '#EF1706'}}>*</span>} labelFor="appId" helperText="Enter the App ID associated with your Messenger application.">
                                <InputGroup
                                    id="appId"
                                    placeholder="Enter App ID here"
                                    name="appId"
                                    value={parent?.state?.messaging?.channels?.messenger?.appId}
                                    onChange={onInputChange}
                                />
                            </FormGroup>
                            <FormGroup style={formGroupStyle} label="App Secret" labelInfo={<span style={{color: '#EF1706'}}>*</span>} labelFor="appSecret" helperText="Enter the App Secret for your Messenger application.">
                                <InputGroup
                                    id="appSecret"
                                    placeholder="Enter App Secret here"
                                    name="appSecret"
                                    value={parent?.state?.messaging?.channels?.messenger?.appSecret}
                                    onChange={onInputChange}
                                />
                            </FormGroup>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '49% 49%', justifyContent: 'space-between' }}>
                            <FormGroup style={formGroupStyle} label="Verify Token" labelInfo={<span style={{color: '#EF1706'}}>*</span>} labelFor="verifyToken" helperText="Provide the verification token for your webhook.">
                                <InputGroup
                                    id="verifyToken"
                                    placeholder="Enter Verify Token here"
                                    name="verifyToken"
                                    value={parent?.state?.messaging?.channels?.messenger?.verifyToken}
                                    onChange={onInputChange}
                                />
                            </FormGroup>
                            <FormGroup style={formGroupStyle} label="Page ID" labelInfo={<span style={{color: '#EF1706'}}>*</span>} labelFor="pageId" helperText="Enter the Page ID of the Facebook Page linked to your Messenger application.">
                                <InputGroup
                                    id="pageId"
                                    placeholder="Enter Page ID here"
                                    name="pageId"
                                    value={parent?.state?.messaging?.channels?.messenger?.pageId}
                                    onChange={onInputChange}
                                />
                            </FormGroup>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '49% 49%', justifyContent: 'space-between' }}>
                            <FormGroup style={formGroupStyle} label="Access Token" labelInfo={<span style={{color: '#EF1706'}}>*</span>} labelFor="accessToken" helperText="Enter the access token generated for your Messenger application.">
                                <InputGroup
                                    id="accessToken"
                                    placeholder="Enter Access Token here"
                                    name="accessToken"
                                    value={parent?.state?.messaging?.channels?.messenger?.accessToken}
                                    onChange={onInputChange}
                                />
                            </FormGroup>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
